/**
 * @file Discover Album Folder Browse Container.
 */

import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import get from 'lodash.get';

import { AlbumFolderForBrowse } from '../../graphql/queries/album-folder';
import DiscoverAlbumFolderBrowse from '../../components/discover/DiscoverAlbumFolderBrowse';

const withAlbumFolderForBrowse = graphql(AlbumFolderForBrowse, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumFolderId,
    },
    notifyOnNetworkStatusChange: true,
  }),
  props: ({ data: { albumFolder, loading } }) => {
    return {
      loading,
      albumFolder: get(albumFolder, 'root'),
    };
  },
});

export default compose(
  withRouter,
  withAlbumFolderForBrowse,
)(DiscoverAlbumFolderBrowse);
